import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import 'stream-browserify'; // see https://github.com/ericgundrum/pouch-websocket-sync-example/commit/2a4437b013092cc7b2cd84cf1499172c84a963a3

import 'subworkers'; // polyfill for https://bugs.chromium.org/p/chromium/issues/detail?id=31666

import url from 'url';
import ByteBuffer from 'bytebuffer';
import MumbleClient from 'mumble-client';
import WorkerBasedMumbleConnector from './worker-client';
import BufferQueueNode from 'web-audio-buffer-queue';
import audioContext from 'audio-context';
import ko from 'knockout';
import _dompurify from 'dompurify';
import keyboardjs from 'keyboardjs';
import { PushToTalkVoiceHandler, initVoice } from './voice';
import { initialize as localizationInitialize, translate } from './loc';

var dompurify = _dompurify(window);

function sanitize(html) {
  return dompurify.sanitize(html, {
    ALLOWED_TAGS: ['br', 'b', 'i', 'u', 'a', 'span', 'p']
  });
}

function openContextMenu(event, contextMenu, target) {
  contextMenu.posX(event.clientX);
  contextMenu.posY(event.clientY);
  contextMenu.target(target);

  var closeListener = function closeListener(event) {
    // Always close, no matter where they clicked
    setTimeout(function () {
      // delay to allow click to be actually processed
      contextMenu.target(null);
      unregister();
    });
  };

  var unregister = function unregister() {
    return document.removeEventListener('click', closeListener);
  };

  document.addEventListener('click', closeListener);
  event.stopPropagation();
  event.preventDefault();
} // GUI


function ContextMenu() {
  var self = this;
  self.posX = ko.observable();
  self.posY = ko.observable();
  self.target = ko.observable();
}

function ConnectDialog() {
  var self = this;
  self.address = ko.observable('');
  self.port = ko.observable('');
  self.tokenToAdd = ko.observable('');
  self.selectedTokens = ko.observableArray([]);
  self.tokens = ko.observableArray([]);
  self.username = ko.observable('');
  self.password = ko.observable('');
  self.channelName = ko.observable('');
  self.joinOnly = ko.observable(false);
  self.visible = ko.observable(true);
  self.show = self.visible.bind(self.visible, true);
  self.hide = self.visible.bind(self.visible, false);

  self.connect = function () {
    self.hide();
    ui.connect(self.username(), self.address(), self.port(), self.tokens(), self.password(), self.channelName());
  };

  self.addToken = function () {
    if (self.tokenToAdd() != "" && self.tokens.indexOf(self.tokenToAdd()) < 0) {
      self.tokens.push(self.tokenToAdd());
    }

    self.tokenToAdd("");
  };

  self.removeSelectedTokens = function () {
    this.tokens.removeAll(this.selectedTokens());
    this.selectedTokens([]);
  };
}

function ConnectErrorDialog(connectDialog) {
  var self = this;
  self.type = ko.observable(0);
  self.reason = ko.observable('');
  self.username = connectDialog.username;
  self.password = connectDialog.password;
  self.joinOnly = connectDialog.joinOnly;
  self.visible = ko.observable(false);
  self.show = self.visible.bind(self.visible, true);
  self.hide = self.visible.bind(self.visible, false);

  self.connect = function () {
    self.hide();
    connectDialog.connect();
  };
}

var ConnectionInfo = /*#__PURE__*/function () {
  function ConnectionInfo(ui) {
    var _this = this;

    _classCallCheck(this, ConnectionInfo);

    this._ui = ui;
    this.visible = ko.observable(false);
    this.serverVersion = ko.observable();
    this.latencyMs = ko.observable(NaN);
    this.latencyDeviation = ko.observable(NaN);
    this.remoteHost = ko.observable();
    this.remotePort = ko.observable();
    this.maxBitrate = ko.observable(NaN);
    this.currentBitrate = ko.observable(NaN);
    this.maxBandwidth = ko.observable(NaN);
    this.currentBandwidth = ko.observable(NaN);
    this.codec = ko.observable();

    this.show = function () {
      if (!ui.thisUser()) return;

      _this.update();

      _this.visible(true);
    };

    this.hide = function () {
      return _this.visible(false);
    };
  }

  _createClass(ConnectionInfo, [{
    key: "update",
    value: function update() {
      var client = this._ui.client;
      this.serverVersion(client.serverVersion);
      var dataStats = client.dataStats;

      if (dataStats) {
        this.latencyMs(dataStats.mean);
        this.latencyDeviation(Math.sqrt(dataStats.variance));
      }

      this.remoteHost(this._ui.remoteHost());
      this.remotePort(this._ui.remotePort());
      var spp = this._ui.settings.samplesPerPacket;
      var maxBitrate = client.getMaxBitrate(spp, false);
      var maxBandwidth = client.maxBandwidth;
      var actualBitrate = client.getActualBitrate(spp, false);
      var actualBandwidth = MumbleClient.calcEnforcableBandwidth(actualBitrate, spp, false);
      this.maxBitrate(maxBitrate);
      this.currentBitrate(actualBitrate);
      this.maxBandwidth(maxBandwidth);
      this.currentBandwidth(actualBandwidth);
      this.codec('Opus'); // only one supported for sending
    }
  }]);

  return ConnectionInfo;
}();

function CommentDialog() {
  var self = this;
  self.visible = ko.observable(false);

  self.show = function () {
    self.visible(true);
  };
}

var SettingsDialog = /*#__PURE__*/function () {
  function SettingsDialog(settings) {
    var _this2 = this;

    _classCallCheck(this, SettingsDialog);

    this.voiceMode = ko.observable(settings.voiceMode);
    this.pttKey = ko.observable(settings.pttKey);
    this.pttKeyDisplay = ko.observable(settings.pttKey);
    this.showAvatars = ko.observable(settings.showAvatars());
    this.userCountInChannelName = ko.observable(settings.userCountInChannelName()); // Need to wrap this in a pureComputed to make sure it's always numeric

    var audioBitrate = ko.observable(settings.audioBitrate);
    this.audioBitrate = ko.pureComputed({
      read: audioBitrate,
      write: function write(value) {
        return audioBitrate(Number(value));
      }
    });
    this.samplesPerPacket = ko.observable(settings.samplesPerPacket);
    this.msPerPacket = ko.pureComputed({
      read: function read() {
        return _this2.samplesPerPacket() / 48;
      },
      write: function write(value) {
        return _this2.samplesPerPacket(value * 48);
      }
    });
  }

  _createClass(SettingsDialog, [{
    key: "applyTo",
    value: function applyTo(settings) {
      settings.voiceMode = this.voiceMode();
      settings.pttKey = this.pttKey();
      settings.showAvatars(this.showAvatars());
      settings.userCountInChannelName(this.userCountInChannelName());
      settings.audioBitrate = this.audioBitrate();
      settings.samplesPerPacket = this.samplesPerPacket();
    }
  }, {
    key: "end",
    value: function end() {
      testVoiceHandler = null;
    }
  }, {
    key: "recordPttKey",
    value: function recordPttKey() {
      var _this3 = this;

      var combo = [];

      var keydown = function keydown(e) {
        combo = e.pressedKeys;
        var comboStr = combo.join(' + ');

        _this3.pttKeyDisplay('> ' + comboStr + ' <');
      };

      var keyup = function keyup() {
        keyboardjs.unbind('', keydown, keyup);
        var comboStr = combo.join(' + ');

        if (comboStr) {
          _this3.pttKey(comboStr).pttKeyDisplay(comboStr);
        } else {
          _this3.pttKeyDisplay(_this3.pttKey());
        }
      };

      keyboardjs.bind('', keydown, keyup);
      this.pttKeyDisplay('> ? <');
    }
  }, {
    key: "totalBandwidth",
    value: function totalBandwidth() {
      return MumbleClient.calcEnforcableBandwidth(this.audioBitrate(), this.samplesPerPacket(), true);
    }
  }, {
    key: "positionBandwidth",
    value: function positionBandwidth() {
      return this.totalBandwidth() - MumbleClient.calcEnforcableBandwidth(this.audioBitrate(), this.samplesPerPacket(), false);
    }
  }, {
    key: "overheadBandwidth",
    value: function overheadBandwidth() {
      return MumbleClient.calcEnforcableBandwidth(0, this.samplesPerPacket(), false);
    }
  }]);

  return SettingsDialog;
}();

var Settings = /*#__PURE__*/function () {
  function Settings(defaults) {
    _classCallCheck(this, Settings);

    var load = function load(key) {
      return window.localStorage.getItem('mumble.' + key);
    };

    this.voiceMode = load('voiceMode') || defaults.voiceMode;
    this.pttKey = load('pttKey') || defaults.pttKey;
    this.toolbarVertical = load('toolbarVertical') || defaults.toolbarVertical;
    this.showAvatars = ko.observable(load('showAvatars') || defaults.showAvatars);
    this.userCountInChannelName = ko.observable(load('userCountInChannelName') || defaults.userCountInChannelName);
    this.audioBitrate = Number(load('audioBitrate')) || defaults.audioBitrate;
    this.samplesPerPacket = Number(load('samplesPerPacket')) || defaults.samplesPerPacket;
  }

  _createClass(Settings, [{
    key: "save",
    value: function save() {
      var save = function save(key, val) {
        return window.localStorage.setItem('mumble.' + key, val);
      };

      save('voiceMode', this.voiceMode);
      save('pttKey', this.pttKey);
      save('toolbarVertical', this.toolbarVertical);
      save('showAvatars', this.showAvatars());
      save('userCountInChannelName', this.userCountInChannelName());
      save('audioBitrate', this.audioBitrate);
      save('samplesPerPacket', this.samplesPerPacket);
    }
  }]);

  return Settings;
}();

var GlobalBindings = function GlobalBindings(config) {
  var _this4 = this;

  _classCallCheck(this, GlobalBindings);

  this.config = config;
  this.settings = new Settings(config.settings);
  this.connector = new WorkerBasedMumbleConnector();
  this.client = null;
  this.userContextMenu = new ContextMenu();
  this.channelContextMenu = new ContextMenu();
  this.connectDialog = new ConnectDialog();
  this.connectErrorDialog = new ConnectErrorDialog(this.connectDialog);
  this.connectionInfo = new ConnectionInfo(this);
  this.commentDialog = new CommentDialog();
  this.settingsDialog = ko.observable();
  this.minimalView = ko.observable(false);
  this.log = ko.observableArray();
  this.remoteHost = ko.observable();
  this.remotePort = ko.observable();
  this.thisUser = ko.observable();
  this.root = ko.observable();
  this.avatarView = ko.observable();
  this.toolbarHorizontal = ko.observable(!this.settings.toolbarVertical);
  this.selected = ko.observable();
  this.selfMute = ko.observable();
  this.selfDeaf = ko.observable();
  this.selfUniqueId = '';
  this.selfMute.subscribe(function (mute) {
    if (voiceHandler) {
      voiceHandler.setMute(mute);
    }
  });

  this.toggleToolbarOrientation = function () {
    _this4.toolbarHorizontal(!_this4.toolbarHorizontal());

    _this4.settings.toolbarVertical = !_this4.toolbarHorizontal();

    _this4.settings.save(); // if (this.toolbarHorizontal()) {
    //   voiceHandler.pttDown();
    // }
    // else {
    //   voiceHandler.pttUp();
    // }

  };

  this.select = function (element) {
    _this4.selected(element);
  };

  this.openSettings = function () {
    _this4.settingsDialog(new SettingsDialog(_this4.settings));
  };

  this.setServerSyncCallback = function (callback) {
    _this4.serverSyncCallback = callback;
  };

  this.setUserLoginCallback = function (callback) {
    _this4.userLoginCallback = callback;
  };

  this.setNewChannelCallback = function (callback) {
    _this4.newChannelCallback = callback;
  };

  this.setRemoveChannelCallback = function (callback) {
    _this4.removeChannelCallback = callback;
  };

  this.setUpdateChannelCallback = function (callback) {
    _this4.updateChannelCallback = callback;
  };

  this.setEnterChannelCallback = function (callback) {
    _this4.enterChannelCallback = callback;
  };

  this.setJoinChannelCallback = function (callback) {
    _this4.joinChannelCallback = callback;
  };

  this.setEntAnnounceCallback = function (callback) {
    _this4.entAnnounceCallback = callback;
  };

  this.setChanAnnounceCallback = function (callback) {
    _this4.chanAnnounceCallback = callback;
  };

  this.setBeKickedCallback = function (callback) {
    _this4.beKickedCallback = callback;
  };

  this.onOfflineMessagesLoaded = function (callback) {
    _this4.onOfflineMessagesLoadedCallback = callback;
  };

  this.setListenStateCallback = function (callback) {
    _this4.listenStateCallback = callback;
  };

  this.setNewUserCallback = function (callback) {
    _this4.newUserCallback = callback;
  };

  this.setRemoveUserCallback = function (callback) {
    _this4.removeUserCallback = callback;
  };

  this.setUpdateUserCallback = function (callback) {
    _this4.updateUserCallback = callback;
  };

  this.setApplyMicCallback = function (callback) {
    _this4.applyMicCallback = callback;
  };

  this.setUserTalkingCallback = function (callback) {
    _this4.userTalkingCallback = callback;
  };

  this.onUserTalkingChanged = function (callback) {
    _this4.onUserTalkingChangedCallback = callback;
  };

  this.setUserCastingCallback = function (callback) {
    _this4.userCastingCallback = callback;
  };

  this.setInstantMessageCallback = function (callback) {
    _this4.instantMessageCallback = callback;
  };

  this.setStartMeetingCallback = function (callback) {
    _this4.startMeetingCallback = callback;
  };

  this.setAnswerMeetingCallback = function (callback) {
    _this4.answerMeetingCallback = callback;
  };

  this.setPcmFrameCallback = function (callback) {
    _this4.pcmFrameCallback = callback;
  };

  this.userLogin = function (host, port, username, password, entid, osName, appstore) {
    console.log('userLogin');

    _this4.connect(username, host, port, '', password, '', entid, osName, appstore);
  };

  this.userLogout = function () {
    console.log('userLogout');

    _this4.resetClient();
  };

  this.userEnterChannel = function (channelId) {
    console.log('userEnterChannel');

    _this4.client.enterChannel(channelId);
  };

  this.userJoinChannel = function (payload) {
    console.log('userJoinChannel');

    _this4.client.joinChannel(payload);
  };

  this.userCreateChannel = function (payload) {
    console.log('userCreateChannel');

    _this4.client.createChannel(payload);
  };

  this.userListenChannel = function (channelId) {
    console.log('userListenChannel');

    _this4.client.listenChannel(channelId);
  };

  this.userUnlistenChannel = function (channelId) {
    console.log('userUnlistenChannel');

    _this4.client.unlistenChannel(channelId);
  };

  this.userSendInstantMessage = function (payload) {
    console.log('userSendInstantMessage');

    _this4.client.sendInstantMessage(payload);
  };

  this.userPushNotifyMessage = function (payload) {
    console.log('userPushNotifyMessage');

    _this4.client.pushNotifyMessage(payload);
  };

  this.userSendEntAnnounceMessage = function (payload) {
    console.log('userSendEntAnnounceMessage');

    _this4.client.sendEntAnnounceMessage(payload);
  };

  this.userSendChanAnnounceMessage = function (payload) {
    console.log('userSendChanAnnounceMessage');

    _this4.client.sendChanAnnounceMessage(payload);
  };

  this.userNeedMoreRecordsMessage = function (payload) {
    console.log('userNeedMoreRecordsMessage');

    _this4.client.sendNeedMoreRecordsMessage(payload);
  };

  this.userStartMeeting = function (payload) {
    console.log('userStartMeeting');

    _this4.client.startMeeting(payload);
  };

  this.userAnswerMeeting = function (payload) {
    console.log('userAnswerMeeting');

    _this4.client.answerMeeting(payload);
  };

  this.getAllChannels = function () {
    return _this4.client._channels;
  };

  this.getAllUsers = function () {
    return _this4.client._users;
  };

  this.userPttDown = function () {
    console.log('userPttDown');
    voiceHandler.pttDown();
  };

  this.userPttUp = function () {
    console.log('userPttUp');
    voiceHandler.pttUp();
  };

  this.applySettings = function () {
    var settingsDialog = _this4.settingsDialog();

    settingsDialog.applyTo(_this4.settings);

    _this4._updateVoiceHandler();

    _this4.settings.save();

    _this4.closeSettings();
  };

  this.closeSettings = function () {
    if (_this4.settingsDialog()) {
      _this4.settingsDialog().end();
    }

    _this4.settingsDialog(null);
  };

  this.getTimeString = function () {
    return '[' + new Date().toLocaleTimeString('en-US') + ']';
  };

  this.connect = function (username, host, port) {
    var tokens = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var password = arguments.length > 4 ? arguments[4] : undefined;
    var channelName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "";
    var entid = arguments.length > 6 ? arguments[6] : undefined;
    var osName = arguments.length > 7 ? arguments[7] : undefined;
    var appstore = arguments.length > 8 ? arguments[8] : undefined;

    _this4.resetClient();

    _this4.remoteHost(host);

    _this4.remotePort(port);

    log(translate('logentry.connecting'), host); // Note: This call needs to be delayed until the user has interacted with
    // the page in some way (which at this point they have), see: https://goo.gl/7K7WLu

    _this4.connector.setSampleRate(audioContext().sampleRate); // TODO: token


    _this4.connector.connect("wss://".concat(host, ":").concat(port), {
      username: username,
      password: password,
      ent_id: entid,
      osname: osName,
      appstore: appstore,
      tokens: tokens
    }).done(function (client) {
      log(translate('logentry.connected'));
      document.getElementById('loginUI').style.display = "none";
      document.getElementById("ic_miniprogram_logout").style.visibility = "visible";
      document.getElementById("ic_miniprogram_menu").style.visibility = "visible";
      document.getElementById('indexUI').style.display = "block";
      _this4.client = client;
      _this4.selfUniqueId = client.self.uniqueId; // Prepare for connection errors

      client.on('error', function (err) {
        log(translate('logentry.connection_error'), err);

        _this4.resetClient();
      }); // Make sure we stay open if we're running as Matrix widget

      window.matrixWidget.setAlwaysOnScreen(true); // Register all channels, recursively 

      if (channelName.indexOf("/") != 0) {
        channelName = "/" + channelName;
      }

      var registerChannel = function registerChannel(channel, channelPath) {
        _this4._newChannel(channel);

        if (channelPath === channelName) {
          client.self.setChannel(channel);
        }

        channel.children.forEach(function (ch) {
          return registerChannel(ch, channelPath + "/" + ch.name);
        });
      };

      registerChannel(client.root, ""); // Register all users

      client.users.forEach(function (user) {
        return _this4._newUser(user);
      });

      if (typeof _this4.serverSyncCallback === "function") {
        console.log('serverSyncResult');

        _this4.serverSyncCallback();
      }

      if (typeof _this4.enterChannelCallback === "function") {
        console.log('serverSyncResult');

        _this4.enterChannelCallback(client.self._channelId);
      }

      if (typeof _this4.joinChannelCallback === "function") {
        console.log('serverSyncResult');

        _this4.joinChannelCallback(client.self._channelId);
      } // Register future channels


      client.on('newChannel', function (channel) {
        return _this4._newChannel(channel);
      }); // Register future users

      client.on('newUser', function (user) {
        return _this4._newUser(user);
      }); // Log permission denied error messages

      client.on('denied', function (type) {
        ui.log.push({
          type: 'generic',
          value: 'Permission denied : ' + type
        });
      }); //zcx add,抢麦/放麦结果回调

      client.on('applyMicResult', function (apply, success) {
        console.log('applyMicResult');

        if (typeof _this4.applyMicCallback === "function") {
          _this4.applyMicCallback(apply, success);
        } //UserTalking在client里处理，这里无需处理


        if (apply) {
          if (success) {
            //抢麦成功
            voiceHandler.nowTalk();
          } else {//todo: notification
          }
        } else {}
      }); //zhangwei

      client.on('enterChannelResult', function (channelId) {
        console.log('enterChannelResult');

        if (typeof _this4.enterChannelCallback === "function") {
          _this4.enterChannelCallback(channelId);
        }
      });
      client.on('joinChannelResult', function (channelId) {
        console.log('joinChannelResult');

        if (typeof _this4.joinChannelCallback === "function") {
          _this4.joinChannelCallback(channelId);
        }
      });
      client.on('sendEntAnnounceResult', function (payload) {
        console.log('sendEntAnnounceResult');

        if (typeof _this4.entAnnounceCallback === "function") {
          _this4.entAnnounceCallback(payload);
        }
      });
      client.on('sendChanAnnounceResult', function (payload) {
        console.log('sendChanAnnounceResult');

        if (typeof _this4.chanAnnounceCallback === "function") {
          _this4.chanAnnounceCallback(payload);
        }
      });
      client.on('onOfflineMessagesResult', function (payload) {
        console.log('onOfflineMessagesResult');

        if (typeof _this4.onOfflineMessagesLoadedCallback === "function") {
          _this4.onOfflineMessagesLoadedCallback(payload);
        }
      });
      client.on('listenStateResult', function (channelId, listen) {
        console.log('listenStateResult');

        if (typeof _this4.listenStateCallback === "function") {
          _this4.listenStateCallback(channelId, listen);
        }
      });
      client.on('userTalkingResult', function (userId, talking) {
        console.log('userTalkingResult');

        if (typeof _this4.userTalkingCallback === "function") {
          _this4.userTalkingCallback(userId, talking);
        }
      });
      client.on('onUserTalkingChangedResult', function (userId, payload) {
        console.log('onUserTalkingChangedResult');

        if (typeof _this4.onUserTalkingChangedCallback === "function") {
          _this4.onUserTalkingChangedCallback(userId, payload);
        }
      });
      client.on('userCastingResult', function (userId, nick, channelId, start, castUrl, videoUrl, time, duration, thumbnail) {
        console.log('userCastingResult');

        if (typeof _this4.userCastingCallback === "function") {
          _this4.userCastingCallback(userId, nick, channelId, start, castUrl, videoUrl, time, duration, thumbnail);
        }
      }); //收到实时消息

      client.on('instantMessageResult', function (from_id, target_id, message_type, content, time, thumbnail, size, duration, orig_name, chan_seq_id, from_nick) {
        if (typeof _this4.instantMessageCallback === "function") {
          _this4.instantMessageCallback(from_id, target_id, message_type, content, time, thumbnail, size, duration, orig_name, chan_seq_id, from_nick);
        }
      }); //收到meeting呼叫

      client.on('startMeetingReceived', function (from_id, from_nick, meeting_id) {
        if (typeof _this4.startMeetingCallback === "function") {
          _this4.startMeetingCallback(from_id, from_nick, meeting_id);
        }
      }); //自己meeting呼叫，收到别人应答

      client.on('answerMeetingReceived', function (user_id, meeting_id, callee_state) {
        if (typeof _this4.answerMeetingCallback === "function") {
          _this4.answerMeetingCallback(user_id, meeting_id, callee_state);
        }
      });
      client.on('pcmAudioResult', function (pcmAudio) {
        console.log('pcmAudioResult');

        if (typeof _this4.pcmFrameCallback === "function") {
          _this4.pcmFrameCallback(pcmAudio);
        }
      }); // Set own user and root channel

      _this4.thisUser(client.self.__ui);

      _this4.root(client.root.__ui); // Startup audio input processing


      _this4._updateVoiceHandler(); // Tell server our mute/deaf state (if necessary)


      if (_this4.selfDeaf()) {
        _this4.client.setSelfDeaf(true);
      } else if (_this4.selfMute()) {
        _this4.client.setSelfMute(true);
      }
    }, function (err) {
      document.getElementById('loginState').innerHTML = "登录失败，请重新尝试";
      document.getElementById("messages").style.visibility = "visible";

      if (err.$type && err.$type.name === 'Reject') {
        console.log('loginResult');

        if (typeof _this4.userLoginCallback === "function") {
          _this4.userLoginCallback(err.type, err.reason);
        } // this.connectErrorDialog.type(err.type)
        // this.connectErrorDialog.reason(err.reason)
        // this.connectErrorDialog.show()

      } else {
        log(translate('logentry.connection_error'), err);
      }
    });
  };

  this._newUser = function (user) {
    var simpleProperties = {
      uniqueId: 'uid',
      username: 'name',
      mute: 'mute',
      deaf: 'deaf',
      suppress: 'suppress',
      selfMute: 'selfMute',
      selfDeaf: 'selfDeaf',
      texture: 'rawTexture',
      textureHash: 'textureHash',
      comment: 'comment'
    };

    if (typeof _this4.newUserCallback === "function") {
      console.log('new user');

      _this4.newUserCallback(user);
    }

    var ui = user.__ui = {
      model: user,
      talking: ko.observable('off'),
      channel: ko.observable()
    };
    ui.texture = ko.pureComputed(function () {
      var raw = ui.rawTexture();
      if (!raw || raw.offset >= raw.limit) return null;
      return 'data:image/*;base64,' + ByteBuffer.wrap(raw).toBase64();
    });

    ui.show_avatar = function () {
      var setting = _this4.settings.showAvatars();

      switch (setting) {
        case 'always':
          break;

        case 'own_channel':
          if (_this4.thisUser().channel() !== ui.channel()) return false;
          break;

        case 'minimal_only':
          if (!_this4.minimalView()) return false;
          if (_this4.thisUser().channel() !== ui.channel()) return false;
          break;

        case 'never':
        default:
          return false;
      }

      if (!ui.texture()) {
        if (ui.textureHash()) {
          // The user has an avatar set but it's of sufficient size to not be
          // included by default, so we need to fetch it explicitly now.
          // mumble-client should make sure we only send one request per hash
          user.requestTexture();
        }

        return false;
      }

      return true;
    };

    ui.openContextMenu = function (_, event) {
      return openContextMenu(event, _this4.userContextMenu, ui);
    };

    ui.canChangeMute = function () {
      return false; // TODO check for perms and implement
    };

    ui.canChangeDeafen = function () {
      return false; // TODO check for perms and implement
    };

    ui.canChangePrioritySpeaker = function () {
      return false; // TODO check for perms and implement
    };

    ui.canLocalMute = function () {
      return false; // TODO implement local mute
      // return this.thisUser() !== ui
    };

    ui.canIgnoreMessages = function () {
      return false; // TODO implement ignore messages
      // return this.thisUser() !== ui
    };

    ui.canChangeComment = function () {
      return false; // TODO implement changing of comments
      // return this.thisUser() === ui // TODO check for perms
    };

    ui.canChangeAvatar = function () {
      return _this4.thisUser() === ui; // TODO check for perms
    };

    ui.toggleMute = function () {
      if (ui.selfMute()) {
        _this4.requestUnmute(ui);
      } else {
        _this4.requestMute(ui);
      }
    };

    ui.toggleDeaf = function () {
      if (ui.selfDeaf()) {
        _this4.requestUndeaf(ui);
      } else {
        _this4.requestDeaf(ui);
      }
    };

    ui.viewAvatar = function () {
      _this4.avatarView(ui.texture());
    };

    ui.changeAvatar = function () {
      var input = document.createElement('input');
      input.type = 'file';
      input.addEventListener('change', function () {
        var reader = new window.FileReader();

        reader.onload = function () {
          _this4.client.setSelfTexture(reader.result);
        };

        reader.readAsArrayBuffer(input.files[0]);
      });
      input.click();
    };

    ui.removeAvatar = function () {
      user.clearTexture();
    };

    Object.entries(simpleProperties).forEach(function (key) {
      ui[key[1]] = ko.observable(user[key[0]]);
    });
    ui.state = ko.pureComputed(userToState, ui);

    if (user.channel) {
      ui.channel(user.channel.__ui);
      ui.channel().users.push(ui);
      ui.channel().users.sort(compareUsers);
    }

    user.on('update', function (actor, properties) {
      Object.entries(simpleProperties).forEach(function (key) {
        if (properties[key[0]] !== undefined) {
          ui[key[1]](properties[key[0]]);
        }
      });

      if (properties.channel !== undefined) {
        if (ui.channel()) {
          ui.channel().users.remove(ui);
        }

        ui.channel(properties.channel.__ui);
        ui.channel().users.push(ui);
        ui.channel().users.sort(compareUsers);

        if (typeof _this4.updateUserCallback === "function") {
          console.log('update user');

          _this4.updateUserCallback();
        }
      }

      if (properties.textureHash !== undefined) {
        // Invalidate avatar texture when its hash has changed
        // If the avatar is still visible, this will trigger a fetch of the new one.
        ui.rawTexture(null);
      }
    }).on('remove', function () {
      if (ui.channel()) {
        ui.channel().users.remove(ui);

        if (typeof _this4.removeUserCallback === "function") {
          console.log('remove user');

          if (ui.model.uniqueId == _this4.selfUniqueId) {
            _this4.beKickedCallback();
          }

          _this4.removeUserCallback();
        }
      }
    }).on('voice', function (stream) {
      console.log("User ".concat(user.username, " started takling"));
      var userNode = new BufferQueueNode({
        audioContext: audioContext()
      });
      userNode.connect(audioContext().destination);
      stream.on('data', function (data) {
        if (data.target === 'normal') {
          ui.talking('on');
        } else if (data.target === 'shout') {
          ui.talking('shout');
        } else if (data.target === 'whisper') {
          ui.talking('whisper');
        }

        userNode.write(data.buffer);
      }).on('end', function () {
        console.log("User ".concat(user.username, " stopped takling"));
        ui.talking('off');
        userNode.end();
      });
    });
  };

  this._newChannel = function (channel) {
    var simpleProperties = {
      position: 'position',
      name: 'name',
      description: 'description',
      member_count: 'member_count',
      max_seq_id: 'max_seq_id',
      creator_id: 'creator_id',
      temporary: 'temporary'
    };

    if (typeof _this4.newChannelCallback === "function") {
      console.log('new channel');

      _this4.newChannelCallback(channel);
    }

    var ui = channel.__ui = {
      model: channel,
      expanded: ko.observable(true),
      parent: ko.observable(),
      channels: ko.observableArray(),
      users: ko.observableArray(),
      linked: ko.observable(false)
    };

    ui.userCount = function () {
      return ui.channels().reduce(function (acc, c) {
        return acc + c.userCount();
      }, ui.users().length);
    };

    ui.openContextMenu = function (_, event) {
      return openContextMenu(event, _this4.channelContextMenu, ui);
    };

    ui.canJoin = function () {
      return true; // TODO check for perms
    };

    ui.canAdd = function () {
      return false; // TODO check for perms and implement
    };

    ui.canEdit = function () {
      return false; // TODO check for perms and implement
    };

    ui.canRemove = function () {
      return false; // TODO check for perms and implement
    };

    ui.canLink = function () {
      return false; // TODO check for perms and implement
    };

    ui.canUnlink = function () {
      return false; // TODO check for perms and implement
    };

    ui.canSendMessage = function () {
      return false; // TODO check for perms and implement
    };

    Object.entries(simpleProperties).forEach(function (key) {
      ui[key[1]] = ko.observable(channel[key[0]]);
    });

    if (channel.parent) {
      ui.parent(channel.parent.__ui);
      ui.parent().channels.push(ui);
      ui.parent().channels.sort(compareChannels);
    }

    channel.on('update', function (properties) {
      Object.entries(simpleProperties).forEach(function (key) {
        if (properties[key[0]] !== undefined) {
          ui[key[1]](properties[key[0]]);
        }
      });

      if (properties.parent !== undefined) {
        if (ui.parent()) {
          ui.parent().channel.remove(ui);
        }

        ui.parent(properties.parent.__ui);
        ui.parent().channels.push(ui);
        ui.parent().channels.sort(compareChannels);
      }

      if (typeof _this4.updateChannelCallback === "function") {
        console.log('update channel');

        _this4.updateChannelCallback();
      }
    }).on('remove', function () {
      if (ui.parent()) {
        ui.parent().channels.remove(ui);

        if (typeof _this4.removeChannelCallback === "function") {
          console.log('remove channel');

          _this4.removeChannelCallback();
        }
      }
    });
  };

  this.resetClient = function () {
    if (_this4.client) {
      _this4.client.disconnect();
    }

    _this4.client = null;

    _this4.selected(null).root(null).thisUser(null);
  };

  this.connected = function () {
    return _this4.thisUser() != null;
  };

  this._updateVoiceHandler = function () {
    if (!_this4.client) {
      return;
    }

    if (voiceHandler) {
      voiceHandler.end();
      voiceHandler = null;
    }

    var mode = _this4.settings.voiceMode;
    voiceHandler = new PushToTalkVoiceHandler(_this4, _this4.client, _this4.settings);
    voiceHandler.on('started_talking', function () {
      if (_this4.thisUser()) {
        _this4.thisUser().talking('on');
      }
    });
    voiceHandler.on('stopped_talking', function () {
      if (_this4.thisUser()) {
        _this4.thisUser().talking('off');
      }
    });

    if (_this4.selfMute()) {
      voiceHandler.setMute(true);
    }

    _this4.client.setAudioQuality(_this4.settings.audioBitrate, _this4.settings.samplesPerPacket);
  };

  this.requestMove = function (user, channel) {
    if (_this4.connected()) {
      user.model.setChannel(channel.model);
      var currentUrl = url.parse(document.location.href, true); // delete search param so that query one can be taken into account

      delete currentUrl.search; // get full channel path

      if (channel.parent()) {
        // in case this channel is not Root
        var parent = channel.parent();
        currentUrl.query.channelName = channel.name();

        while (parent.parent()) {
          currentUrl.query.channelName = parent.name() + '/' + currentUrl.query.channelName;
          parent = parent.parent();
        }
      } else {
        // there is no channelName as we moved to Root
        delete currentUrl.query.channelName;
      } // reflect this change in URL


      window.history.pushState(null, channel.name(), url.format(currentUrl)); //zcx add. todo: 在EnterChannel的回调里移动

      var chanName = channel.name();
      var posLeft = chanName.lastIndexOf('(');
      var posRight = chanName.lastIndexOf(')');
      var strId = chanName.substring(posLeft + 1, posRight);
      var iId = parseInt(strId);

      _this4.client.enterChannel(iId);
    }
  };

  this.requestListen = function (user, channel) {
    var chanName = channel.name();
    var posLeft = chanName.lastIndexOf('(');
    var posRight = chanName.lastIndexOf(')');
    var strId = chanName.substring(posLeft + 1, posRight);
    var iId = parseInt(strId);

    _this4.client.listenChannel(iId);
  };

  this.requestUnlisten = function (user, channel) {
    var chanName = channel.name();
    var posLeft = chanName.lastIndexOf('(');
    var posRight = chanName.lastIndexOf(')');
    var strId = chanName.substring(posLeft + 1, posRight);
    var iId = parseInt(strId);

    _this4.client.unlistenChannel(iId);
  };

  this.openSourceCode = function () {
    var homepage = require('../../package.json').homepage;

    window.open(homepage, '_blank').focus();
  };

  this.updateSize = function () {
    _this4.minimalView(window.innerWidth < 320);

    if (_this4.minimalView()) {
      _this4.toolbarHorizontal(window.innerWidth < window.innerHeight);
    } else {
      _this4.toolbarHorizontal(!_this4.settings.toolbarVertical);
    }
  };
};

var OnLongPressEvent = /*#__PURE__*/function () {
  function OnLongPressEvent(container, onLongPressEvent, onLongPressFinishEvent) {
    _classCallCheck(this, OnLongPressEvent);

    this.container = container;
    this.onLongPressEvent = onLongPressEvent;
    this.onLongPressFinishEvent = onLongPressFinishEvent;
    this.timeOutEvent = null;
    this.onMouseDownListener = null;
    this.onMouseUpListener = null;
    this.onMouseMoveListener = null; //flag标志，两种情况：
    // 1.按住不移动松开 onMouseDown ->> onMouseUp
    // 2.按住移动松开   onMouseDown ->> onMouseMove ->> onLongPressFinishEvent

    this.isMouseDown = false;
    this.mouse = {
      x: 0,
      y: 0
    };
    this.initMouseListener(); // this.enableLongPress()
  }
  /**
   * 初始化按下、抬起、移动的监听事件
   * @param{Object} container
   */


  _createClass(OnLongPressEvent, [{
    key: "initMouseListener",
    value: function initMouseListener() {
      var _this5 = this;

      this.onMouseDownListener = function (event) {
        _this5.onMouseDown(event);
      };

      this.onMouseUpListener = function (event) {
        _this5.onMouseUp(event);
      };

      this.onMouseMoveListener = function (event) {
        _this5.onMouseMove(event);
      };
    }
    /**
     * 使能长按功能
     */

  }, {
    key: "enableLongPress",
    value: function enableLongPress() {
      this.container.addEventListener("pointerdown", this.onMouseDownListener);
      this.container.addEventListener("pointerup", this.onMouseUpListener);
      this.container.addEventListener("pointermove", this.onMouseMoveListener);
    }
    /**
     * 禁用长按功能
     */

  }, {
    key: "disableLongPress",
    value: function disableLongPress() {
      this.container.removeEventListener("pointerdown", this.onMouseDownListener);
      this.container.removeEventListener("pointerup", this.onMouseUpListener);
      this.container.removeEventListener("pointermove", this.onMouseMoveListener());
    }
    /**
     * 设置事件元素
     * @param {Object} container
     */

  }, {
    key: "setLongPressContainer",
    value: function setLongPressContainer(container) {
      this.container = container;
    }
    /**
     * 设置更新按钮事件
     * @param {Object} onLongPressEvent
     */

  }, {
    key: "setLongPressEvent",
    value: function setLongPressEvent(onLongPressEvent) {
      this.onLongPressEvent = onLongPressEvent;
    }
    /**
     * 设置更新按钮完成事件
     * @param {Object} onLongPressFinishEvent
     */

  }, {
    key: "setLongPressFinishEvent",
    value: function setLongPressFinishEvent(onLongPressFinishEvent) {
      this.onLongPressFinishEvent = onLongPressFinishEvent;
    }
    /**
     * 按下事件
     * @param {Object} event
     */

  }, {
    key: "onMouseDown",
    value: function onMouseDown(event) {
      var _this6 = this;

      console.log("onMouseDown 触发");
      this.cancelTimeoutEvent();
      this.mouse.x = event.x;
      this.mouse.y = event.y;
      this.timeOutEvent = setTimeout(function () {
        if (_this6.onLongPressEvent != null) {
          _this6.onLongPressEvent();

          console.log("长按事件 触发");
          _this6.isMouseDown = true;
        }
      }, 10);
    }
    /**
     * 抬起监听
     * @param {Object} event
     */

  }, {
    key: "onMouseUp",
    value: function onMouseUp(event) {
      if (this.isMouseDown) {
        this.cancelTimeoutEvent();
        this.onLongPressFinishEvent();
        this.isMouseDown = false;
        console.log("长按事件 结束");
      }
    }
    /**
     * 移动监听
     * @param {Object} event
     */

  }, {
    key: "onMouseMove",
    value: function onMouseMove(event) {
      // console.log(" pointermove", event.x)
      var x = Math.abs(this.mouse.x - event.x);
      var y = Math.abs(this.mouse.y - event.y);

      if (x > 3 || y > 3) {
        // this.cancelTimeoutEvent(event)
        if (this.isMouseDown) {
          this.isMouseDown = false;
          console.log("isMouseDown   false");
          this.onLongPressFinishEvent();
        }
      }
    }
    /**
     * 取消长按触发计时器事件
     */

  }, {
    key: "cancelTimeoutEvent",
    value: function cancelTimeoutEvent() {
      if (this.timeOutEvent != null) {
        clearTimeout(this.timeOutEvent);
        this.timeOutEvent = null;
      }
    }
    /**
     * 释放资源
     */

  }, {
    key: "dispose",
    value: function dispose() {
      this.cancelTimeoutEvent();
      this.disableLongPress();
      this.container = null;
      this.onLongPressEvent = null;
      this.onLongPressFinishEvent = null;
      this.timeOutEvent = null;
      this.onMouseDownListener = null;
      this.onMouseUpListener = null;
      this.onMouseMoveListener = null;
      this.mouse = null;
    }
  }]);

  return OnLongPressEvent;
}();

var ui = new GlobalBindings(window.mumbleWebConfig); // Used only for debugging

window.totalkAPI = ui;

function initializeUI() {
  var queryParams = url.parse(document.location.href, true).query;
  queryParams = Object.assign({}, window.mumbleWebConfig.defaults, queryParams);
  var useJoinDialog = queryParams.joinDialog;

  if (queryParams.matrix) {
    useJoinDialog = true;
  }

  if (queryParams.address) {
    ui.connectDialog.address(queryParams.address);
  } else {
    useJoinDialog = false;
  }

  if (queryParams.port) {
    ui.connectDialog.port(queryParams.port);
  } else {
    useJoinDialog = false;
  }

  if (queryParams.token) {
    var tokens = queryParams.token;

    if (!Array.isArray(tokens)) {
      tokens = [tokens];
    }

    ui.connectDialog.tokens(tokens);
  }

  if (queryParams.username) {
    ui.connectDialog.username(queryParams.username);
  } else {
    useJoinDialog = false;
  }

  if (queryParams.password) {
    ui.connectDialog.password(queryParams.password);
  }

  if (queryParams.channelName) {
    ui.connectDialog.channelName(queryParams.channelName);
  }

  if (queryParams.avatarurl) {
    // Download the avatar and upload it to the mumble server when connected
    var _url = queryParams.avatarurl;
    console.log('Fetching avatar from', _url);
    var req = new window.XMLHttpRequest();
    req.open('GET', _url, true);
    req.responseType = 'arraybuffer';

    req.onload = function () {
      var upload = function upload(avatar) {
        if (req.response) {
          console.log('Uploading user avatar to server');
          ui.client.setSelfTexture(req.response);
        }
      }; // On any future connections


      ui.thisUser.subscribe(function (thisUser) {
        if (thisUser) {
          upload();
        }
      }); // And the current one (if already connected)

      if (ui.thisUser()) {
        upload();
      }
    };

    req.send();
  }

  ui.connectDialog.joinOnly(useJoinDialog);
  ko.applyBindings(ui);

  window.onresize = function () {
    return ui.updateSize();
  };

  ui.updateSize();
}

function log() {
  console.log(console);
  console.log(arguments[0]);

  if (arguments[0] == "Connection error:") {
    console.log("execute Connection error");
    document.getElementById('confirmWindow').style.display = 'block';
    document.getElementById('confirm_btn_cancel').style.display = 'none';
    document.getElementById('confirmWindow').setAttribute('confirmType', '2');
    document.getElementById('confirmWindowContent').innerText = '您已经断开链接，请重新登录。';
  }

  console.log.apply(console, arguments);
  var args = [];

  for (var i = 0; i < arguments.length; i++) {
    args.push(arguments[i]);
  }

  ui.log.push({
    type: 'generic',
    value: args.join(' ')
  });
}

function compareChannels(c1, c2) {
  if (c1.position() === c2.position()) {
    return c1.name() === c2.name() ? 0 : c1.name() < c2.name() ? -1 : 1;
  }

  return c1.position() - c2.position();
}

function compareUsers(u1, u2) {
  return u1.name() === u2.name() ? 0 : u1.name() < u2.name() ? -1 : 1;
}

function userToState() {
  var flags = []; // TODO: Friend

  if (this.uid()) {
    flags.push('Authenticated');
  } // TODO: Priority Speaker, Recording


  if (this.mute()) {
    flags.push('Muted (server)');
  }

  if (this.deaf()) {
    flags.push('Deafened (server)');
  } // TODO: Local Ignore (Text messages), Local Mute


  if (this.selfMute()) {
    flags.push('Muted (self)');
  }

  if (this.selfDeaf()) {
    flags.push('Deafened (self)');
  }

  return flags.join(', ');
}

var voiceHandler;
var testVoiceHandler;
/**
 * @author svartoyg
 */

function translatePiece(selector, kind, parameters, key) {
  var element = document.querySelector(selector);

  if (element !== null) {
    var translation = translate(key);

    switch (kind) {
      default:
        console.warn('unhandled dom translation kind "' + kind + '"');
        break;

      case 'textcontent':
        element.textContent = translation;
        break;

      case 'attribute':
        element.setAttribute(parameters.name || 'value', translation);
        break;
    }
  } else {
    console.warn("translation selector \"".concat(selector, "\" for \"").concat(key, "\" did not match any element"));
  }
}
/**
 * @author svartoyg
 */


function translateEverything() {
  translatePiece('#connect-dialog_title', 'textcontent', {}, 'connectdialog.title');
  translatePiece('#connect-dialog_input_address', 'textcontent', {}, 'connectdialog.address');
  translatePiece('#connect-dialog_input_port', 'textcontent', {}, 'connectdialog.port');
  translatePiece('#connect-dialog_input_username', 'textcontent', {}, 'connectdialog.username');
  translatePiece('#connect-dialog_input_password', 'textcontent', {}, 'connectdialog.password');
  translatePiece('#connect-dialog_input_tokens', 'textcontent', {}, 'connectdialog.tokens');
  translatePiece('#connect-dialog_controls_remove', 'textcontent', {}, 'connectdialog.remove');
  translatePiece('#connect-dialog_controls_add', 'textcontent', {}, 'connectdialog.add');
  translatePiece('#connect-dialog_controls_cancel', 'attribute', {
    'name': 'value'
  }, 'connectdialog.cancel');
  translatePiece('#connect-dialog_controls_connect', 'attribute', {
    'name': 'value'
  }, 'connectdialog.connect');
  translatePiece('.connect-dialog.error-dialog .dialog-header', 'textcontent', {}, 'connectdialog.error.title');
  translatePiece('.connect-dialog.error-dialog .reason .refused', 'textcontent', {}, 'connectdialog.error.reason.refused');
  translatePiece('.connect-dialog.error-dialog .reason .version', 'textcontent', {}, 'connectdialog.error.reason.version');
  translatePiece('.connect-dialog.error-dialog .reason .username', 'textcontent', {}, 'connectdialog.error.reason.username');
  translatePiece('.connect-dialog.error-dialog .reason .userpassword', 'textcontent', {}, 'connectdialog.error.reason.userpassword');
  translatePiece('.connect-dialog.error-dialog .reason .serverpassword', 'textcontent', {}, 'connectdialog.error.reason.serverpassword');
  translatePiece('.connect-dialog.error-dialog .reason .username-in-use', 'textcontent', {}, 'connectdialog.error.reason.username_in_use');
  translatePiece('.connect-dialog.error-dialog .reason .full', 'textcontent', {}, 'connectdialog.error.reason.full');
  translatePiece('.connect-dialog.error-dialog .reason .clientcert', 'textcontent', {}, 'connectdialog.error.reason.clientcert');
  translatePiece('.connect-dialog.error-dialog .reason .server', 'textcontent', {}, 'connectdialog.error.reason.server');
  translatePiece('.connect-dialog.error-dialog .alternate-username', 'textcontent', {}, 'connectdialog.username');
  translatePiece('.connect-dialog.error-dialog .alternate-password', 'textcontent', {}, 'connectdialog.password');
  translatePiece('.connect-dialog.error-dialog .dialog-submit', 'attribute', {
    'name': 'value'
  }, 'connectdialog.error.retry');
  translatePiece('.connect-dialog.error-dialog .dialog-close', 'attribute', {
    'name': 'value'
  }, 'connectdialog.error.cancel');
  translatePiece('.join-dialog .dialog-header', 'textcontent', {}, 'joindialog.title');
  translatePiece('.join-dialog .dialog-submit', 'attribute', {
    'name': 'value'
  }, 'joindialog.connect');
  translatePiece('.user-context-menu .information', 'textcontent', {}, 'usercontextmenu.information');
  translatePiece('.user-context-menu .add-friend', 'textcontent', {}, 'usercontextmenu.add_friend');
  translatePiece('.user-context-menu .remove-friend', 'textcontent', {}, 'usercontextmenu.remove_friend');
  translatePiece('.channel-context-menu .join', 'textcontent', {}, 'channelcontextmenu.join');
  translatePiece('.channel-context-menu .listen', 'textcontent', {}, 'channelcontextmenu.listen');
  translatePiece('.channel-context-menu .unlisten', 'textcontent', {}, 'channelcontextmenu.unlisten');
  translatePiece('.channel-context-menu .edit', 'textcontent', {}, 'channelcontextmenu.edit');
  translatePiece('.channel-context-menu .remove', 'textcontent', {}, 'channelcontextmenu.remove');
}

function main() {
  return _main.apply(this, arguments);
}

function _main() {
  _main = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return localizationInitialize(navigator.language);

          case 2:
            translateEverything();
            initializeUI();
            initVoice(function (data) {
              if (testVoiceHandler) {
                testVoiceHandler.write(data);
              }

              if (!ui.client) {
                if (voiceHandler) {
                  voiceHandler.end();
                }

                voiceHandler = null;
              } else if (voiceHandler) {
                voiceHandler.write(data);
              }
            }, function (err) {
              log(translate('logentry.mic_init_error'), err);
            });

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _main.apply(this, arguments);
}

window.onload = main;
console.log('window.onload**********');